import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import UnpairedPaymentStatus from "entities/unpairedPaymentStatus";
import { DateRange } from "@edaz/edazkit/DateRangeInput";
import BankAccount from "../bankAccount";
import { Type } from "class-transformer";

export default class PaymentFilter {
  @Type(() => BankAccount)
  @observable
  bankAccount: BankAccount = new BankAccount();
  @observable variableSymbol?: string;
  @observable constantSymbol?: string;
  @observable specificSymbol?: string;
  @observable paidAmount?: number;
  @observable status?: UnpairedPaymentStatus;
  @observable postingDate?: DateRange;
  @observable messageForRecipient?: string;
}

export const PaymentFilterValidationRules: EntityValidationRules<PaymentFilter> = {
  variableSymbol: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  constantSymbol: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  specificSymbol: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  messageForRecipient: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
};
